export function filterProducts() {
  //
}

export function removeClassOnAll(elements, nameOfClass) {
  elements.forEach((element) => {
    element.classList.remove(nameOfClass)
  })
}

export function showAll(button, whatAreWeFiltering, hiddenClass) {
  button.addEventListener('click', (e) => {
    removeClassOnAll(whatAreWeFiltering, hiddenClass)
  })
}

export function filterPeople() {
  const people = [...document.querySelectorAll('.c-card--person')]
  const buttons = [...document.querySelectorAll('.c-filter__unit')]
  const activeClass = 'u-is-shown'
  const hiddenClass = 'u-is-hidden'

  buttons.forEach((button) => {
    button.addEventListener('click', (e) => {
      if (button.dataset.category === 'all') {
        showAll(button, people, hiddenClass)
        return
      }
      people.forEach((person) => {
        const personCategories = person.dataset.category.split(':')

        if (personCategories.indexOf(button.dataset.category) !== -1) {
          person.classList.remove(hiddenClass)
        } else {
          person.classList.add(hiddenClass)
        }
      })
    })
  })
  const firstBtnInputElement = buttons[0].querySelector('.c-filter__btn')
  firstBtnInputElement.click()
}

export function filterReferences() {
  const references = [...document.querySelectorAll('.c-card--ref')]
  const buttons = [...document.querySelectorAll('.c-filter__unit')]
  // const activeClass = 'u-is-shown'
  const hiddenClass = 'u-is-hidden'

  buttons.forEach((button) => {
    button.addEventListener('click', (e) => {
      history.replaceState({}, '', `${button.dataset.category}`)

      if (button.dataset.category === '#all') {
        showAll(button, references, hiddenClass)
        return
      }

      references.forEach((reference) => {
        if (reference.dataset.category === button.dataset.category) {
          reference.classList.remove(hiddenClass)
        } else {
          reference.classList.add(hiddenClass)
        }
      })
    })
  })
}
